import { type SkinPageConfig, templates } from '@nosinovacao/nosid-mfe-common';
import { MfaSetupSheetLight } from './mfa-setup-sheet.light';
import { type MfaSetupSheetProps } from './props';

export { useMfaSetupSheet } from './context';
export { type MfaSetupSheetProps } from './props';

export function MfaSetupSheet(props: Readonly<MfaSetupSheetProps>) {
  return templates.getSkinSelector(skinSelector(props));
}

function skinSelector(props: MfaSetupSheetProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <MfaSetupSheetLight {...props} />,
  };
}
